import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../../auth/auth-guard.service';
import { MetierComponent } from './metier.component';
import { MetiersComponent } from './metiers.component';

const routes: Routes = [
  {
    path: '',
    component: MetiersComponent, canActivate: [AuthGuard],
    data: { permissions: ['adminAccess']},
    children: [

      {
        path: 'liste',
        component:MetierComponent,
        canActivate: [AuthGuard],
        data: { permissions: ['adminAccess', 'adminEditUser']},
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MetiersRoutingModule { }

export const routedComponents = [
  MetiersComponent,
  MetierComponent
];
